export const ARTICLE_CLICK = 'Article Click';
export const HELP_ARTICLE_WAS_HELPFUL = 'Help Article was Helpful';
export const SUBMIT_QUESTION = 'Submit Question';
export const SUBTOPIC_SELECTED = 'Subtopic Selected';
export const START_NEW_CONVERSATION = 'Start New Conversation';
export const TOPIC_SELECTED = 'Topic Selected';
